<template>
  <div class="archive card" v-if="active">
    <article class="archive-content" v-for="post in activePosts" :key="post.id">
      <router-link 
        :to="{ name : routeName, params : { name: post.slug }}"
        >
        <figure>
          <div class="aspect-fix w19h10">
            <div class="container">
              <img class="thumbnail lazyload" :data-src="thumbnailSrc(post)" :alt="post.title.rendered" />
            </div>
          </div>
          <figcaption>
            <h3 class="title">{{post.title.rendered}}</h3>
            <div class="work-info">
              <span class="description" v-if="post.acf.description">{{post.acf.description}}</span>
              <span class="year">{{post.acf.year}}</span>
            </div>
          </figcaption>
        </figure>
      </router-link>
    </article>
  </div>
</template>



<script>
import PageData from "@/mixins/PageData";

export default {
  mixins: [PageData],
  props: {
    name: String,
    routeName: String,
    filterTags: Array,
    excludeId: Number,
    length: {
      type: Number,
      default: 0,
    },
    relatedPosts:Number,
  },
  data: () => ({
    posts: null,
    active: false,
  }),
  computed: {
    activePosts() {
      
      if(this.filterTags == null || this.filterTags.length==0) return this.length>0 ? this.posts.slice(0, this.length) : this.posts;

      var results = [];
      
      for(var p=0; p<this.posts.length; p++){

        if(this.posts[p].id === this.excludeId) continue;

        let found = false;
        for(var i=0; i<this.filterTags.length; i++){
          if(this.posts[p].tags.includes(this.filterTags[i])){
            found = true;
            break;
          }
        }
        if(found){
           results.push(this.posts[p])
           if(this.length>0 && results.length >= this.length) break;
        }
      }
      return results.length == 0 ? (this.length>0 ? this.posts.slice(0, this.length) : this.posts) : results;
    },

    thumbnailSrc: () => post => {
      return post["featured_image"] == null ? "" : post["featured_image"].src;
    },
    thumbnailSrcset: () => post => {
      return post["featured_image"] == null ? "" : post["featured_image"].srcset;
    }
  },
  mounted() {
    this.active = false;

    // this.pageLoading();
    this.getArchive(this.name).then((data)=>{
        
      this.posts = data;
      this.active = true;
      this.$emit('loaded')
      // this.pageLoaded();
    });

  },
};
</script>